import { useMemo } from "react";
import { Maps } from "../MapTileLayer";
import {
  TileRowsContainer,
  TileRow,
  LayerTileContainer,
  LayerTileImageContainer,
  LayerTileImage,
  LayerTileText,
} from "./Styles";

interface Row {
  key: string;
  tiles: MapTile[];
}

export interface MapTile {
  title: string;
  background: string;
  layer: Maps;
}

interface Props {
  tiles: MapTile[];
  activeLayer: Maps;
  onChangeActiveLayer: (layer: Maps) => void;
}

export function MapTilesContainer(props: Props) {
  const tileRows = useMemo(() => {
    // Create rows of 2 tiles each.
    const rows: Row[] = [];
    props.tiles.forEach((tile, index) => {
      const rowIndex = Math.floor(index / 2);
      if (rowIndex > rows.length - 1) {
        rows.push({ key: `row-${rowIndex}`, tiles: [] });
      }
      rows[rowIndex].tiles.push(tile);
    });
    return rows;
  }, [props.tiles]);

  return (
    <TileRowsContainer rowCount={tileRows.length}>
      {tileRows.map((row) => (
        <TileRow key={row.key}>
          {row.tiles.map((tile) => (
            <LayerTileContainer key={tile.title}>
              <LayerTileImageContainer>
                <LayerTileImage
                  background={tile.background}
                  active={props.activeLayer === tile.layer}
                  onClick={() => {
                    props.onChangeActiveLayer(tile.layer);
                  }}
                ></LayerTileImage>
              </LayerTileImageContainer>
              <LayerTileText>{tile.title}</LayerTileText>
            </LayerTileContainer>
          ))}
          {row.tiles.length === 1 && <div></div>}
        </TileRow>
      ))}
    </TileRowsContainer>
  );
}
